import { fetchApi } from '../lib/apiClient';

/**
 * Credits 用量数据类型
 */
export interface CreditsUsageData {
  month: string;
  messageCount: number;
  costUsd: number;
  costCny: number;
  creditsUsed: number;
  creditsLimit: number;
  creditsRemaining: number;
  isOverLimit: boolean;
}

// 简单的内存缓存
interface CacheEntry {
  data: CreditsUsageData;
  timestamp: number;
}

const cache = new Map<string, CacheEntry>();
const CACHE_DURATION = 5 * 60 * 1000; // 5分钟

/**
 * 获取用户 Credits 用量
 * @returns Credits 用量数据
 */
export const getCreditsUsage = async (): Promise<CreditsUsageData> => {
  const cacheKey = 'credits-usage';
  
  // 检查缓存
  const cached = cache.get(cacheKey);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }

  try {
    const data = await fetchApi<CreditsUsageData>('/profiles/me/credits-usage');
    
    // 更新缓存
    cache.set(cacheKey, {
      data,
      timestamp: Date.now(),
    });
    
    return data;
  } catch (error) {
    console.error('获取 Credits 用量失败:', error);
    throw error;
  }
};

/**
 * 清除缓存
 */
export const clearCreditsUsageCache = (): void => {
  cache.clear();
};
